import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisaCodigoPromocional = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('regtron/codigospromocionais/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );

            dispatchresponse(dispatch,response.data,types.PRODUTOS.PESQUISA_CODIGOPROMOCIONAL);

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const zerapesquisa = () => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.PESQUISA_CODIGOPROMOCIONAL,
        payload: {}
      })
    }
}

export const codigoselecionado = (dados = {}) => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.CODIGOPROMOSELECIONADO,
        payload: dados
      })
    }
}

export const zeracodigoselecionado = () => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.CODIGOPROMOSELECIONADO,
        payload: {}
      })
    }
}

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{

            const response = await axios.put('regtron/codigospromocionais/novoatualiza',
                {
                    ...dados
                }
                ,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }                    
                }
            );

            dispatchresponse(dispatch,response.data,types.PRODUTOS.PRODNOVOATUALIZA);

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const zeranovoatualiza = () => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.PRODNOVOATUALIZA,
        payload: {}
      })
    }
}
